import Api from './api';

export default new Api(process.env.REACT_APP_API_URL, 'id_token');
